import { useAppRouter as V } from "../../providers/AppRouterProvider/AppRouterProvider.js";
import { cn as m } from "../../../lib/shadcn/utils/utils.js";
import { Badge as y } from "../../ui/Badge/Badge.js";
import { useEffect as E, useMemo as p, useState as F } from "react";
import { Fragment as H, jsx as e, jsxs as u } from "react/jsx-runtime";
import { IDS as k } from "@my-medication/e2e-page-objects/selectors";
import { useTranslation as q } from "react-i18next";
import { cva as z } from "class-variance-authority";
import { BadgeType as w } from "@my-medication/bff-interfaces-ui/shared/components";
var G = z("", {
  variants: {
    variant: {
      header: "flex h-20 border-0 border-b-4 border-solid border-b-transparent p-0",
      headerMenu: "block border-0 border-b border-solid border-secondary-300 p-4"
    },
    active: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [{
    variant: "header",
    active: !0,
    className: "border-b-primary-600 bg-white"
  }, {
    variant: "headerMenu",
    active: !0,
    className: "bg-secondary-050"
  }]
}), _ = ({ linkName: r, name: l = null, ariaLabel: N, subtitle: f = "", status: t = null, statusIcon: h, icon: j, routeParams: o = null, disabled: C = !1, badgeContent: v = 0, variant: s, className: L, dataTestid: R, onNavigationElementClicked: M }) => {
  const { i18n: S } = q(), { getCurrent: I, navigateTo: T, resolveRoute: b, onRouteChange: g } = V(), [c, A] = F(() => I());
  E(() => g((a) => A(a)), [g]);
  const n = o?.locale || S.language, i = p(() => ({
    ...o,
    locale: n
  }), [o, n]), d = p(() => {
    const a = c?.params?.locale === n;
    return (c?.matched ?? []).some((D) => D.name === r) && a;
  }, [
    c,
    r,
    n
  ]), B = p(() => b({
    name: r,
    params: i
  }).href, [
    b,
    r,
    i
  ]), x = /* @__PURE__ */ e(H, { children: /* @__PURE__ */ u("div", {
    className: "contents",
    children: [
      /* @__PURE__ */ u("div", {
        className: m("relative flex w-full items-start lg:items-center!", t && "mb-2"),
        children: [
          j,
          v ? /* @__PURE__ */ e("div", {
            className: "absolute -top-1.25 left-2.75 flex h-4.5 w-4.5 items-center justify-center",
            "data-testid": "badge",
            children: /* @__PURE__ */ e(y, {
              variant: w.red,
              shape: "circle",
              label: String(v)
            })
          }) : null,
          /* @__PURE__ */ u("div", {
            className: "flex flex-col",
            children: [/* @__PURE__ */ e("span", {
              className: m(s === "header" ? "p-0" : "pl-2.5", d && s === "headerMenu" && "lg:font-semibold"),
              children: l
            }), !!f.trim() && /* @__PURE__ */ e("span", {
              className: "pl-2.5 text-secondary-800 lg:hidden",
              children: f
            })]
          })
        ]
      }),
      t && /* @__PURE__ */ e(y, {
        className: "px-2 py-1 uppercase",
        variant: w.dark,
        label: t
      }),
      !t && h && d && /* @__PURE__ */ e("span", { children: h })
    ]
  }) });
  return /* @__PURE__ */ e("li", {
    "data-testid": R ?? k.navItem(r.toLowerCase().replace(/\s+/g, "-")),
    className: m(G({
      variant: s,
      active: d
    }), L),
    onClick: () => M?.(l || r),
    children: C ? /* @__PURE__ */ e("div", {
      className: "flex w-full items-center justify-between text-secondary-900",
      children: x
    }) : /* @__PURE__ */ e("a", {
      href: B,
      "aria-label": l ? void 0 : N,
      className: "flex w-full items-center justify-between text-secondary-900 no-underline",
      onClick: (a) => {
        a.preventDefault(), T({
          name: r,
          params: i
        });
      },
      children: x
    })
  });
};
export {
  _ as NavigationItem
};

//# sourceMappingURL=NavigationItem.js.map